module.exports = __webpack_public_path__ + "img/remote-dirc.c316952b.png";